import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../store';

import { IEventItem } from '../../store/player/events/store';

export const useGetPlayerEvent = (eventId: number | string | undefined) => {
  const [event, setEvent] = useState<IEventItem>();

  const { events } = useContext(GlobalContext);

  useEffect(() => {
    if (eventId && events[Number(eventId)]) {
      setEvent(events[Number(eventId)]);
    }
  }, [events, eventId]);

  return event;
};
